var map = {
	"./prot-1000.png": "ecfa",
	"./prot-17000.png": "b570",
	"./prot-2000.png": "2f9d",
	"./prot-24000.png": "906b",
	"./prot-300.png": "11a2",
	"./prot-40000.png": "a958",
	"./prot-700.png": "c97e",
	"./prot-7000.png": "d56c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "132b";